<div class="cf-dialog">
  <div class="cf-dialog__header">
    <h2 class="cf-dialog__title">{{ LABELS.TITLE }}</h2>
    <button type="button" class="cf-dialog__close" (click)="cancel()" aria-label="Close">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <div class="cf-dialog__divider"></div>

  <div class="cf-dialog__body">
    <div class="cf-field" [class.cf-field--error]="hasNameError">
      <one-input [label]="LABELS.NAME" [(ngModel)]="name"></one-input>
      <span class="cf-field__error" *ngIf="hasNameError">{{ LABELS.REQUIRED }}</span>
    </div>

    <div class="cf-field" [class.cf-field--error]="hasEmailError">
      <one-input [label]="LABELS.EMAIL" type="email" [(ngModel)]="email"></one-input>
      <span class="cf-field__error" *ngIf="hasEmailError">{{ LABELS.EMAIL_ERROR }}</span>
    </div>

    <div class="cf-field">
      <one-input [label]="LABELS.PHONE" [(ngModel)]="phone"></one-input>
    </div>

    <div class="cf-field">
      <one-input [label]="LABELS.ROLE" [(ngModel)]="role"></one-input>
    </div>
  </div>

  <div class="cf-dialog__footer">
    <button type="button" class="rp-button rp-outlined rp-primary" (click)="cancel()">
      {{ COMMON.CANCEL }}
    </button>
    <button
      type="button"
      class="rp-button rp-filled rp-primary"
      [disabled]="isSaving"
      (click)="confirm()"
    >
      {{ isSaving ? COMMON.SAVING : LABELS.CONFIRM }}
    </button>
  </div>
</div>
